import type { IScope } from "angular";
import "angular-translate";
import { capitalize, lowerCase } from "lodash";

import type { IContactInformation, IResponseWithLoading, ISite } from "App/Modules/Models";
import type { IModalService } from "App/Modules/Services";

export default class ContactInformationComponentController {
    public static $inject: string[] = ["$scope", "$translate", "mmModalService"];

    public isLoading: boolean;

    public subCaption: string;

    public addressesCount: number;

    public emailsCount: number;

    public phoneNumbersCount: number;

    public site: IResponseWithLoading<ISite>;

    constructor(
        private readonly $scope: IScope,
        private readonly $translate: ng.translate.ITranslateService,
        private readonly modalService: IModalService,
    ) {}

    public $onChanges() {
        if (this.site && this.site.data) {
            this.addressesCount = this.site.data.contactInformation.addresses.length;
            this.emailsCount = this.site.data.contactInformation.emails.length;
            this.phoneNumbersCount = this.site.data.contactInformation.phoneNumbers.length;

            this.updateSubCaption(this.addressesCount, this.emailsCount, this.phoneNumbersCount);

            this.isLoading = false;
        } else {
            this.isLoading = true;
        }
    }

    public editContactInformation(contactInformation: IContactInformation) {
        this.modalService
            .open<IContactInformation, ISite>("mmEditSiteContactInformation", contactInformation, this.site.data)
            .subscribe(
                (editResponse) => {
                    this.site.data.contactInformation = editResponse;

                    this.addressesCount = this.site.data.contactInformation.addresses.length;
                    this.emailsCount = this.site.data.contactInformation.emails.length;
                    this.phoneNumbersCount = this.site.data.contactInformation.phoneNumbers.length;

                    this.updateSubCaption(this.addressesCount, this.emailsCount, this.phoneNumbersCount);
                },
                (reason) => reason,
            );
    }

    private updateSubCaption(addressesCount: number, emailsCount: number, phoneNumbersCount: number) {
        this.$translate(
            [
                "Entities.ContactInformation.AddressesCountFormat",
                "Entities.ContactInformation.EmailsCountFormat",
                "Entities.ContactInformation.PhoneNumbersCountFormat",
            ],
            {
                addressesCount,
                emailsCount,
                phoneNumbersCount,
            },
            "messageformat",
        ).then((translations) => {
            this.subCaption = `${capitalize(
                translations["Entities.ContactInformation.PhoneNumbersCountFormat"],
            )}, ${lowerCase(translations["Entities.ContactInformation.EmailsCountFormat"])}, ${lowerCase(
                translations["Entities.ContactInformation.AddressesCountFormat"],
            )}`;
        });
    }
}
